import TiptapImage from '@tiptap/extension-image';
import { Plugin } from '@tiptap/pm/state';
import type { Node } from '@tiptap/react';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { CustomizedImage } from './CustomizedImage';
import { insertImage } from './logic';

export const CustomImage: Node = TiptapImage.extend({
  draggable: true,
  addAttributes() {
    return {
      ...this.parent?.(),
      width: { default: '100%' },
      position: { default: 'center' },
      loading: { default: 'false' },
      style: {
        default: 'width: 100%; height: auto; cursor: pointer;',
        parseHTML: (element) => {
          const width = element.getAttribute('width');
          return width
            ? `width: ${width}px; height: auto; cursor: pointer;`
            : `${element.style.cssText}`;
        },
      },
    };
  },
  addNodeView() {
    return ReactNodeViewRenderer(CustomizedImage);
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          handleDOMEvents: {},
          handleDrop: (view, event, _, moved) => {
            const hasFiles = event.dataTransfer?.files.length;
            if (!hasFiles || moved) {
              return false;
            }

            const imageFiles = Array.from(event.dataTransfer.files).filter(
              (file) => file.type.startsWith('image/'),
            );

            if (imageFiles.length === 0) {
              return false;
            }

            event.preventDefault();
            event.stopPropagation();

            imageFiles.forEach((file) => {
              insertImage({ file, view: view, type: this.type });
            });

            return true;
          },
          handlePaste: (view, event) => {
            const hasFiles = event.clipboardData?.files;
            if (!hasFiles) {
              return false;
            }

            const files = Array.from(event.clipboardData?.files);
            const imageFiles = files.filter((file) =>
              file.type.startsWith('image/'),
            );

            if (imageFiles.length === 0) {
              return false;
            }

            event.preventDefault();
            event.stopPropagation();

            imageFiles.forEach((file) => {
              insertImage({ file, view: view, type: this.type });
            });

            return true;
          },
        },
      }),
    ];
  },
}).configure({ inline: true });
